import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ErrorIcon from "@material-ui/icons/Error";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import moment from "moment-timezone";
import React from "react";

import { DateTime } from "../Date";

const useStyles = makeStyles(
  theme => ({
    avatar: {
      left: -45,
      position: "absolute",
      top: 0
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative",
      borderLeft: "10px solid #EC5D77",
      border: "1px solid #EC5D77"
    },
    card1: {
      marginBottom: theme.spacing(5),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)"
    },
    date: {
      color: theme.typography.caption.color
    },
    errorContainer: {
      display: "flex"
    },
    failedReasonIcon: {
      color: "#EC5D77",
      marginRight: "8px"
    },
    message: {
      color: "#EC5D77"
    },
    root: {
      position: "relative"
    },
    title: {
      "& p": {
        fontSize: "14px"
      },
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(),
      paddingLeft: theme.spacing(3),
      textAlign: "right"
    },
    type: {
      color: "#EC5D77"
    },
    titleText: {
      color: "#000000"
    }
  }),
  { name: "TimelineNote" }
);

interface TimelineNoteNationwide3plErrorProps {
  date: string;
  message: string | null;
  user: any;
  title?: string;
  titleTextColor?: string;
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("lll");
};

export const TimelineNoteNationwide3plError: React.FC<TimelineNoteNationwide3plErrorProps> = props => {
  const {
    date,
    message,
    title = "Failed booking",
    titleTextColor = "#EC5D77"
  } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <Avatar
        className={classes.avatar}
        style={{ background: "#6051E3", color: "white" }}
      >
        <LocalShippingOutlinedIcon color="inherit" />
      </Avatar>

      <div className={classes.title}>
        <Typography style={{ color: titleTextColor }}>{title}</Typography>
        <Typography className={classes.date}>
          <Typography>
            <DateTime date={date} />
          </Typography>
          <Typography>{dateFormat(date)}</Typography>
        </Typography>
      </div>

      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <div className={classes.errorContainer}>
            <ErrorIcon className={classes.failedReasonIcon} />
            <Typography
              className={classes.message}
              dangerouslySetInnerHTML={{
                __html: message.replace(/\n/g, "<br />")
              }}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
TimelineNoteNationwide3plError.displayName = "TimelineNote";
export default TimelineNoteNationwide3plError;
